import _default from './Select';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/addons/Select/index.js
// module id = 279
// module chunks = 0